import getConfig from "next/config";

import Heading from "@components/Heading";
import PhoneBuyBackSectionHeader from "@components/PhoneBuyBack/PhoneBuyBackSectionHeader";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

const steps = [
  {
    step: 1,
    title: "Vezi valoarea estimativa a vechiului tau telefon",
    content:
      "Cu ajutorul calculatorului nostru online, poți vedea cu usurinta cat valoreaza vechiul tau dispozitiv.",
  },
  {
    step: 2,
    title: "Vino in magazin",
    content: `Pentru stabilirea valorii finale, vino cu telefonul în cel mai apropiat magazin ${websiteTitle}.`,
  },
  {
    step: 3,
    title: "Alege noul produs",
    content:
      "Cu voucher-ul primit poti achizitiona orice produs din magazin in termen de 7 zile.",
  },
];

const PhoneBuyBackSteps = () => {
  return (
    <>
      <div className="mb-[60px] md:mb-[90px]">
        <PhoneBuyBackSectionHeader
          title={
            <Heading
              as="h2"
              title="Buy Back-ul pentru Telefoane nu a fost niciodata mai usor."
              font="semibold"
              classesProp="mb-[15px]"
            />
          }
        >
          Îti vom oferi o estimare a valorii vechiului tau dispozitiv, online
          sau in magazin.
        </PhoneBuyBackSectionHeader>
      </div>

      <div className="space-y-[60px] md:space-y-0 md:flex md:gap-[20px]">
        {steps.map(({ step, content, title }) => (
          <div
            className="text-center border border-black rounded-[10px] relative"
            key={step}
          >
            <div className="py-[45px] px-[40px] md:flex md:flex-col md:justify-between md:h-full">
              <div className="text-[22px] font-semibold mb-[10px]">{title}</div>

              <div className="text-[14px]">{content}</div>
            </div>

            <div className="absolute -top-[30px] left-0 right-0 w-[60px] h-[60px] leading-[60px] m-auto text-[32px] text-white bg-black rounded-full">
              {step}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PhoneBuyBackSteps;
